module.exports = __webpack_public_path__ + "l.no2.cebf06f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/l.no2.jpg
// module id = omZz
// module chunks = 0